<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-pencil"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'produtos-edit.texts.editar_produto' | translate }}</h1>
    <p class="header-subtitle">{{ 'produtos-edit.texts.subtitulo_editar' | translate }}</p>
  </div>
</div>

<!-- Banner: item de sistema (nao-editavel em campos criticos) -->
<div *ngIf="ehItemDeSistema"
  class="surface-50 border-1 surface-border border-round-lg p-3 mb-4 flex align-items-center gap-2">
  <i class="pi pi-shield text-primary"></i>
  <span class="text-700 font-medium">
    {{ 'produtos.texts.item_de_sistema_banner' | translate }}
  </span>
</div>

<!-- Grid de Cards -->
<div class="cards-container">
  <!-- Coluna Esquerda -->
  <div class="column-left">
    <!-- Card Informacao Geral -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon">
          <i class="pi pi-info-circle"></i>
        </div>
        <span class="card-header-title">{{ 'produtos-edit.texts.informacao_geral' | translate }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field half">
            <label class="form-label">{{ 'produtos-edit.labels.nome' | translate }} <span class="required">*</span></label>
            <input [class.error-field]="isFormSubmitted && !form.nome" [(ngModel)]="form.nome" type="text" pInputText
              [readonly]="ehItemDeSistema"
              placeholder="{{ 'produtos-edit.placeholders.digite_o_nome_do_produto' | translate }}" class="w-full" />
          </div>
          <div class="form-field half">
            <label class="form-label">{{ 'produtos-edit.labels.codigo_de_barras' | translate }}</label>
            <input [(ngModel)]="form.barras" type="text" pInputText
              placeholder="{{ 'produtos-edit.placeholders.digite_o_codigo_de_barras' | translate }}" class="w-full" />
          </div>
          <div class="form-field third">
            <label class="form-label">{{ 'produtos-edit.labels.grupo' | translate }} <span class="required">*</span></label>
            <app-select-grupo id="categoria" name="grupo_id" [(ngModel)]="form.grupo_id" [returnType]="'id'" (ngModelChange)="onGrupoChange($event)" [class.error-field]="isFormSubmitted && !form.grupo_id" />
            <small class="error-message" *ngIf="isFormSubmitted && !form.grupo_id">{{ 'common.campo_obrigatorio' | translate }}</small>
          </div>
          <div class="form-field third">
            <label class="form-label">{{ 'produtos-edit.labels.sub_grupo' | translate }}</label>
            <app-select-subgrupo id="subCategoria" name="subGrupo_id" [(ngModel)]="form.subGrupo_id" [returnType]="'id'" [grupoId]="form.grupo_id" />
          </div>
          <div class="form-field third">
            <label class="form-label">{{ 'produtos-edit.labels.marca' | translate }}</label>
            <app-select-marca id="marca" name="marca_id" [(ngModel)]="form.marca_id" [returnType]="'id'" />
          </div>
          <div class="form-field half">
            <label class="form-label">{{ 'produtos-edit.labels.tipo_de_item' | translate }} <span class="required">*</span></label>
            <p-dropdown [class.error-field]="isFormSubmitted && !form.tipoItem" [options]="tipoDeItensOptions"
              optionLabel="label" [(ngModel)]="form.tipoItem"
              [disabled]="ehItemDeSistema"
              [placeholder]="getTipoItemLabel()" styleClass="w-full"></p-dropdown>
          </div>
          <div class="form-field half">
            <label class="form-label">{{ 'produtos-edit.labels.status' | translate }}</label>
            <div class="status-toggle-container">
              <p-inputSwitch [(ngModel)]="form.status"
                [disabled]="ehItemDeSistema"
                class="status-switch"></p-inputSwitch>
              <span class="status-label" [ngClass]="{'status-active': form.status, 'status-inactive': !form.status}">
                {{ form.status ? ('produtos-edit.texts.ativo' | translate) : ('produtos-edit.texts.inativo' | translate) }}
              </span>
            </div>
          </div>
          <div class="form-field half minishop-highlight">
            <label class="form-label">
              <i class="pi pi-shopping-bag minishop-icon"></i>
              {{ 'produtos-edit.labels.disponivel_mini_shop' | translate }}
            </label>
            <div class="status-toggle-container">
              <p-inputSwitch
                [(ngModel)]="form.habilitarMiniShopping"
                [disabled]="!habilitarMiniShoppingEmpresaConfig"
                (onChange)="onMiniShopChange()"
                class="status-switch minishop-switch">
              </p-inputSwitch>
              <span class="status-label" [ngClass]="{'minishop-active': form.habilitarMiniShopping, 'status-inactive': !form.habilitarMiniShopping}">
                {{ form.habilitarMiniShopping ? ('produtos-edit.texts.sim' | translate) : ('produtos-edit.texts.nao' | translate) }}
              </span>
            </div>
          </div>
          <div class="form-field half">
            <label class="form-label">{{ 'produtos-edit.labels.preco_de_venda' | translate }} <span class="required">*</span></label>
            <p-inputNumber
              [(ngModel)]="form.precoDeVenda"
              [currency]="currencyCode"
              [locale]="locale"
              [minFractionDigits]="casasDecimaisDaMoeda"
              [maxFractionDigits]="casasDecimaisDaMoeda"
              [useGrouping]="true"
              [monetaryMask]="casasDecimaisDaMoeda"
              [min]="0"
              [readonly]="ehItemDeSistema"
              (onFocus)="onPrecoDeVendaFocus()"
              (onBlur)="onPrecoDeVendaBlur()"
              [class.error-field]="isFormSubmitted && precoDeVendaInvalido"
              [placeholder]="'produtos-edit.placeholders.digite_o_preco_de_venda' | translate"
              inputStyleClass="w-full"
              styleClass="w-full">
            </p-inputNumber>
          </div>
          <div class="form-field half">
            <label class="form-label">{{ 'produtos-edit.labels.custo' | translate }} <span class="required">*</span></label>
            <p-inputNumber
              [(ngModel)]="form.custo"
              [currency]="currencyCode"
              [locale]="locale"
              [minFractionDigits]="casasDecimaisDaMoeda"
              [maxFractionDigits]="casasDecimaisDaMoeda"
              [useGrouping]="true"
              [monetaryMask]="casasDecimaisDaMoeda"
              [readonly]="ehItemDeSistema"
              [class.error-field]="isFormSubmitted && form.custo == null"
              [placeholder]="'produtos-edit.placeholders.digite_o_custo' | translate"
              inputStyleClass="w-full"
              styleClass="w-full">
            </p-inputNumber>
          </div>
          <div class="form-field full">
            <label class="form-label">{{ 'produtos-edit.labels.descricao' | translate }}</label>
            <textarea [(ngModel)]="form.descricao" pInputTextarea [rows]="2" [autoResize]="true"
              placeholder="{{ 'produtos-edit.placeholders.digite_a_descricao' | translate }}" class="w-full"></textarea>
          </div>
          <div class="form-field full">
            <label class="form-label">{{ 'produtos-edit.labels.imagem' | translate }}</label>
            <div class="product-image-container" *ngIf="form.imagem">
              <img class="product-image product-image-clicavel"
                   [src]="imagePreviewUrl"
                   alt="Imagem do produto"
                   (click)="abrirImagemExpandida()"
                   [title]="'produtos-edit.texts.clique_para_expandir' | translate" />
              <button pButton class="p-button p-button-icon-only" icon="pi pi-trash" (click)="onClearImage()"></button>
            </div>
            <p-fileUpload name="grupo" [multiple]="false" accept="image/jpeg,image/png,image/gif" [maxFileSize]="2000000"
              [showUploadButton]="false" [showCancelButton]="true"
              chooseLabel="{{'grupo.botoes.selecionar_imagem' | translate}}"
              cancelLabel="{{'grupo.botoes.remover' | translate}}" (onSelect)="onSelectImage($event)"
              (onClear)="onClearImage()">
            </p-fileUpload>
          </div>

          <!-- Imagens secundarias do item (so em modo edicao - precisa do itemId) -->
          <div class="form-field full" *ngIf="form.id">
            <app-item-imagens-secundarias
              [itemId]="form.id"
              [disabled]="ehItemDeSistema"></app-item-imagens-secundarias>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Estoque -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon stock-icon">
          <i class="pi pi-warehouse"></i>
        </div>
        <span class="card-header-title">{{ 'produtos-edit.texts.estoque' | translate }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field half">
            <label class="form-label">{{ 'produtos-edit.labels.saldo' | translate }} <span class="required">*</span></label>
            <app-input-quantidade [class.error-field]="isFormSubmitted && form.saldo == null" [(ngModel)]="form.saldo"
              [casasDecimais]="casasDecimaisEstoque"
              [style]="{ width: '100%' }"></app-input-quantidade>
          </div>
          <div class="form-field half">
            <label class="form-label">{{ 'produtos-edit.labels.estoque_minimo' | translate }} <span class="required">*</span></label>
            <app-input-quantidade [class.error-field]="isFormSubmitted && form.estoqueMinimo == null" [(ngModel)]="form.estoqueMinimo"
              [casasDecimais]="casasDecimaisEstoque"
              [style]="{ width: '100%' }"></app-input-quantidade>
          </div>
          <div class="form-field half">
            <label class="form-label">{{ 'produtos-edit.labels.unidade_de_medida' | translate }} <span class="required">*</span></label>
            <p-dropdown [class.error-field]="isFormSubmitted && !form.unidadeMedidaDeItem_id" [options]="unidadesMedida"
              optionLabel="label" optionValue="value" [(ngModel)]="form.unidadeMedidaDeItem_id"
              (onChange)="onUnidadeMedidaChange()"
              placeholder="{{ 'produtos-edit.placeholders.selecione' | translate }}" styleClass="w-full">
            </p-dropdown>
          </div>
          <div class="form-field half">
            <label class="form-label">{{ 'produtos-edit.labels.fornecedor_principal' | translate }}</label>
            <p-dropdown [options]="fornecedores" optionLabel="label" optionValue="value"
              [(ngModel)]="form.fornecedorPrincipal_id"
              placeholder="{{ 'produtos-edit.placeholders.selecione' | translate }}" styleClass="w-full">
            </p-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Coluna Direita -->
  <div class="column-right">
    <!-- Card Dados Adicionais -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon additional-icon">
          <i class="pi pi-cog"></i>
        </div>
        <span class="card-header-title">{{ 'produtos-edit.texts.dados_adicionais' | translate }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field full">
            <label class="form-label">{{ 'produtos-edit.labels.tipo_de_imposto' | translate }} <span class="required">*</span></label>
            <p-dropdown [class.error-field]="isFormSubmitted && !form.tipoDeImposto" [options]="tipoDeImpostoOptions"
              optionLabel="label" optionValue="value" [(ngModel)]="form.tipoDeImposto"
              [placeholder]="getTipoImpostoLabel()" styleClass="w-full"></p-dropdown>
          </div>
          <div class="form-field half" *ngIf="imprimirItensDeAcordoImpressoraEmpresaConfig">
            <label class="form-label">{{ 'produtos-edit.labels.impressora_predeterminada' | translate }}</label>
            <p-dropdown [options]="impressoras" optionLabel="label" optionValue="value"
              [(ngModel)]="form.impressoraPadraoId" placeholder="{{ 'produtos-edit.placeholders.selecione' | translate }}" styleClass="w-full">
            </p-dropdown>
          </div>
          <div class="form-field half" *ngIf="imprimirAutomaticoPedidoEmpresaConfig">
            <label class="form-label">{{ 'produtos-edit.labels.impressora_pedido' | translate }}</label>
            <p-dropdown [options]="impressoras" optionLabel="label" optionValue="value"
              [(ngModel)]="form.impressoraPadraoPedidoId" placeholder="{{ 'produtos-edit.placeholders.selecione' | translate }}"
              [showClear]="true" styleClass="w-full">
            </p-dropdown>
          </div>
          <div class="form-field half" *ngIf="imprimirItensDeAcordoImpressoraEmpresaConfig">
            <label class="form-label">{{ 'produtos-edit.labels.imprimir_itens_segundo_impressora' | translate }}</label>
            <p-dropdown [options]="permiteImprimir" optionLabel="label" optionValue="value"
              [(ngModel)]="form.permiteImprimir" styleClass="w-full">
            </p-dropdown>
          </div>
          <div class="form-field half" *ngIf="imprimirAutomaticoPedidoEmpresaConfig">
            <label class="form-label">{{ 'produtos-edit.labels.imprimir_itens_segundo_impressora_pedido' | translate }}</label>
            <p-dropdown [options]="permiteImprimir" optionLabel="label" optionValue="value"
              [(ngModel)]="form.permiteImprimirPedido" styleClass="w-full">
            </p-dropdown>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Promocao e Novidade (visivel apenas com MiniShop ativo e nao item de sistema — RN08) -->
    <div class="form-card" *ngIf="form.habilitarMiniShopping && !ehItemDeSistema">
      <div class="card-header">
        <div class="card-header-icon additional-icon">
          <i class="pi pi-star"></i>
        </div>
        <span class="card-header-title">{{ 'produtos.texts.promocao_e_novidade' | translate }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field third">
            <label class="form-label">{{ 'produtos.labels.promocao' | translate }}</label>
            <div class="status-toggle-container">
              <p-inputSwitch
                inputId="switchPromocaoEdit"
                [(ngModel)]="promocao"
                (onChange)="onPromocaoChange()"
                class="status-switch">
              </p-inputSwitch>
              <span class="status-label" [ngClass]="{'status-active': promocao, 'status-inactive': !promocao}">
                {{ promocao ? ('produtos.labels.sim' | translate) : ('produtos.labels.nao' | translate) }}
              </span>
            </div>
          </div>
          <div class="form-field third" *ngIf="promocao">
            <label class="form-label">{{ 'produtos.labels.promocao_ate' | translate }} <span class="required">*</span></label>
            <p-calendar
              [(ngModel)]="promocaoAteEmData"
              [showTime]="true"
              [showSeconds]="false"
              hourFormat="24"
              [minDate]="dataMinimaPromocaoNovidade"
              appendTo="body"
              dateFormat="dd/mm/yy"
              styleClass="w-full">
            </p-calendar>
          </div>
          <div class="form-field third">
            <label class="form-label">{{ 'produtos.labels.novidade' | translate }}</label>
            <div class="status-toggle-container">
              <p-inputSwitch
                inputId="switchNovidadeEdit"
                [(ngModel)]="novidade"
                (onChange)="onNovidadeChange()"
                class="status-switch">
              </p-inputSwitch>
              <span class="status-label" [ngClass]="{'status-active': novidade, 'status-inactive': !novidade}">
                {{ novidade ? ('produtos.labels.sim' | translate) : ('produtos.labels.nao' | translate) }}
              </span>
            </div>
          </div>
          <div class="form-field third" *ngIf="novidade">
            <label class="form-label">{{ 'produtos.labels.novidade_ate' | translate }} <span class="required">*</span></label>
            <p-calendar
              [(ngModel)]="novidadeAteEmData"
              [showTime]="true"
              [showSeconds]="false"
              hourFormat="24"
              [minDate]="dataMinimaPromocaoNovidade"
              appendTo="body"
              dateFormat="dd/mm/yy"
              styleClass="w-full">
            </p-calendar>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Variantes de Preco (apenas no modo de edicao) -->
    <div class="form-card variantes-card" *ngIf="idEdit">
      <div class="card-header">
        <div class="card-header-icon variantes-icon">
          <i class="pi pi-tags"></i>
        </div>
        <span class="card-header-title">{{ 'produtos-edit.texts.variantes_de_preco' | translate }}</span>
      </div>
      <div class="card-content">
        <p class="variantes-descricao">{{ 'produtos-edit.texts.variantes_descricao' | translate }}</p>

        <!-- Lista de variantes -->
        <div *ngFor="let variante of variantes; let i = index; trackBy: trackByVariante" class="variante-item">
          <div class="variante-campos">
            <div class="form-field variante-descricao-field">
              <label class="form-label">{{ 'produtos-edit.labels.variante_descricao' | translate }}</label>
              <input
                #varianteDescricaoInput
                [(ngModel)]="variante.descricao"
                (ngModelChange)="onVarianteChange(i)"
                type="text"
                pInputText
                placeholder="{{ 'produtos-edit.placeholders.variante_descricao' | translate }}"
                class="w-full" />
            </div>
            <div class="form-field variante-preco-field">
              <label class="form-label">{{ 'produtos-edit.labels.variante_preco' | translate }}</label>
              <p-inputNumber
                [(ngModel)]="variante.precoDeVenda"
                (ngModelChange)="onVarianteChange(i)"
                [currency]="currencyCode"
                [locale]="locale"
                [minFractionDigits]="casasDecimaisDaMoeda"
                [maxFractionDigits]="casasDecimaisDaMoeda"
                [useGrouping]="true"
                [monetaryMask]="casasDecimaisDaMoeda"
                placeholder="0"
                inputStyleClass="w-full"
                styleClass="w-full">
              </p-inputNumber>
            </div>
          </div>
          <div class="variante-acoes">
            <button pButton
              icon="pi pi-trash"
              class="p-button-rounded p-button-text p-button-danger"
              (click)="removerVariante(i)"
              [pTooltip]="'produtos-edit.tooltips.remover_variante' | translate">
            </button>
          </div>
          <span class="auto-save-status" *ngIf="varianteSaveStatus.get(i) as status">
            <i class="pi" [ngClass]="{
              'pi-spin pi-spinner': status === 'salvando',
              'pi-check': status === 'salvo',
              'pi-exclamation-circle': status === 'erro'
            }"></i>
            <small>{{ status === 'salvando' ? ('produtos-edit.texts.salvando' | translate) :
                      status === 'salvo' ? ('produtos-edit.texts.salvo' | translate) :
                      status === 'erro' ? ('produtos-edit.texts.erro_salvar' | translate) : '' }}</small>
          </span>
        </div>

        <!-- Estado vazio -->
        <div *ngIf="variantes.length === 0" class="variantes-empty">
          <i class="pi pi-tags variantes-empty-icon"></i>
          <p>{{ 'produtos-edit.texts.sem_variantes' | translate }}</p>
        </div>

        <!-- Botao adicionar variante -->
        <button pButton
          icon="pi pi-plus"
          class="p-button-outlined p-button-sm w-full btn-adicionar-variante"
          (click)="adicionarVariante()">
          {{ 'produtos-edit.botoes.adicionar_variante' | translate }}
        </button>
      </div>
    </div>

    <!-- Card Grupos de Modificadores (apenas no modo de edicao) -->
    <div class="form-card modificadores-card" *ngIf="idEdit">
      <div class="card-header">
        <div class="card-header-icon modificadores-icon">
          <i class="pi pi-sliders-h"></i>
        </div>
        <span class="card-header-title">{{ 'produtos-edit.texts.modificadores' | translate }}</span>
      </div>
      <div class="card-content">
        <p class="variantes-descricao">{{ 'produtos-edit.texts.modificadores_descricao' | translate }}</p>

        <!-- Lista de grupos de modificadores -->
        <div *ngFor="let grupo of gruposModificadores; let gi = index; trackBy: trackByGrupo" class="grupo-modificador">

          <!-- Cabecalho do grupo -->
          <div class="grupo-header">
            <div class="grupo-campos-vertical">
              <div class="grupo-nome-row">
                <div class="form-field flex-1">
                  <label class="form-label">{{ 'produtos-edit.labels.grupo_modificador_pergunta' | translate }}</label>
                  <input
                    #grupoDescricaoInput
                    [(ngModel)]="grupo.descricao"
                    (ngModelChange)="onGrupoModificadorChange(gi)"
                    type="text"
                    pInputText
                    placeholder="{{ 'produtos-edit.placeholders.grupo_modificador_pergunta' | translate }}"
                    class="w-full" />
                </div>
                <div class="grupo-acoes">
                  <button pButton
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="removerGrupoModificador(gi)"
                    [pTooltip]="'produtos-edit.tooltips.remover_grupo' | translate">
                  </button>
                </div>
              </div>
              <div class="grupo-config-row">
                <div class="grupo-toggle-item">
                  <label class="form-label">{{ 'produtos-edit.labels.cliente_deve_escolher' | translate }}</label>
                  <p-inputSwitch
                    [ngModel]="grupo.minimoDeModificadores > 0"
                    (ngModelChange)="onToggleObrigatorio(gi, $event)">
                  </p-inputSwitch>
                </div>
                <div class="grupo-toggle-item">
                  <label class="form-label">{{ 'produtos-edit.labels.pode_escolher_mais_de_um' | translate }}</label>
                  <p-inputSwitch
                    [ngModel]="grupo.maximoDeModificadores > 1"
                    (ngModelChange)="onToggleMultiplo(gi, $event)">
                  </p-inputSwitch>
                </div>
                <div class="grupo-toggle-item" *ngIf="grupo.maximoDeModificadores > 1">
                  <label class="form-label">{{ 'produtos-edit.labels.ate_quantos' | translate }}</label>
                  <p-inputNumber
                    [(ngModel)]="grupo.maximoDeModificadores"
                    (ngModelChange)="onGrupoModificadorChange(gi)"
                    [min]="2"
                    [max]="20"
                    styleClass="grupo-ate-quantos-input">
                  </p-inputNumber>
                </div>
              </div>
            </div>
            <span class="auto-save-status" *ngIf="grupoSaveStatus.get(gi) as status">
              <i class="pi" [ngClass]="{
                'pi-spin pi-spinner': status === 'salvando',
                'pi-check': status === 'salvo',
                'pi-exclamation-circle': status === 'erro'
              }"></i>
              <small>{{ status === 'salvando' ? ('produtos-edit.texts.salvando' | translate) :
                        status === 'salvo' ? ('produtos-edit.texts.salvo' | translate) :
                        status === 'erro' ? ('produtos-edit.texts.erro_salvar' | translate) : '' }}</small>
            </span>
          </div>

          <!-- Opcoes do grupo (so exibe se o grupo ja foi salvo) -->
          <div *ngIf="grupo.id" class="opcoes-container">
            <label class="opcoes-section-label">{{ 'produtos-edit.labels.opcoes_disponiveis' | translate }}</label>
            <div *ngFor="let mod of grupo.modificadores; let mi = index; trackBy: trackByModificador" class="opcao-item">
              <div class="form-field flex-1">
                <label class="form-label" *ngIf="mi === 0">{{ 'produtos-edit.labels.opcao_nome' | translate }}</label>
                <input
                  #modificadorDescricaoInput
                  [(ngModel)]="mod.descricao"
                  (ngModelChange)="onModificadorChange(gi, mi)"
                  type="text"
                  pInputText
                  placeholder="{{ 'produtos-edit.placeholders.opcao_nome' | translate }}"
                  class="w-full" />
              </div>
              <div class="form-field opcao-preco-field">
                <label class="form-label" *ngIf="mi === 0">{{ 'produtos-edit.labels.preco_adicional' | translate }}</label>
                <p-inputNumber
                  [(ngModel)]="mod.precoDeVenda"
                  (ngModelChange)="onModificadorChange(gi, mi)"
                  [currency]="currencyCode"
                  [locale]="locale"
                  [minFractionDigits]="casasDecimaisDaMoeda"
                  [maxFractionDigits]="casasDecimaisDaMoeda"
                  [useGrouping]="true"
                  [monetaryMask]="casasDecimaisDaMoeda"
                  placeholder="0"
                  inputStyleClass="w-full"
                  styleClass="w-full">
                </p-inputNumber>
              </div>
              <span class="auto-save-status" *ngIf="modificadorSaveStatus.get(gi + '-' + mi) as status">
                <i class="pi" [ngClass]="{
                  'pi-spin pi-spinner': status === 'salvando',
                  'pi-check': status === 'salvo',
                  'pi-exclamation-circle': status === 'erro'
                }"></i>
              </span>
              <button pButton
                icon="pi pi-trash"
                class="p-button-rounded p-button-text p-button-danger p-button-sm"
                [ngClass]="{'opcao-btn-primeira-linha': mi === 0}"
                (click)="removerModificador(gi, mi)"
                [pTooltip]="'produtos-edit.tooltips.remover_opcao' | translate">
              </button>
            </div>

            <!-- Botao adicionar opcao -->
            <button pButton
              icon="pi pi-plus"
              class="p-button-text p-button-sm btn-adicionar-opcao"
              (click)="adicionarModificador(gi)">
              {{ 'produtos-edit.botoes.adicionar_opcao' | translate }}
            </button>
          </div>


        </div>

        <!-- Estado vazio -->
        <div *ngIf="gruposModificadores.length === 0" class="variantes-empty">
          <i class="pi pi-sliders-h variantes-empty-icon"></i>
          <p>{{ 'produtos-edit.texts.sem_modificadores' | translate }}</p>
        </div>

        <!-- Botao adicionar grupo -->
        <button pButton
          icon="pi pi-plus"
          class="p-button-outlined p-button-sm w-full btn-adicionar-variante"
          (click)="adicionarGrupoModificador()">
          {{ 'produtos-edit.botoes.adicionar_grupo_modificador' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Botoes de Acao -->
<div class="actions-container">
  <button pButton (click)="navigateListaDeProdutos()"
    severity="secondary" icon="pi pi-arrow-left" class="btn-secondary">
    {{ 'produtos-edit.botoes.voltar' | translate }} (Esc)
  </button>
  <button pButton icon="pi pi-check"
    (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
    {{ 'produtos-edit.botoes.atualizar' | translate }} (Ctrl+Enter)
  </button>
</div>

<!-- Lightbox - Imagem expandida -->
<div class="image-lightbox-overlay"
     *ngIf="imagemExpandida"
     (click)="fecharImagemExpandida()"
     [@fadeAnimation]>
  <button class="lightbox-close-btn" (click)="fecharImagemExpandida()">
    <i class="pi pi-times"></i>
  </button>
  <img class="lightbox-image"
       [src]="imagePreviewUrl"
       alt="Imagem do produto expandida"
       (click)="$event.stopPropagation()" />
</div>

<p-toast></p-toast>

<!-- Dialog de confirmacao de remocao de grupo de modificador -->
<p-dialog
  [(visible)]="mostrarDialogRemoverGrupo"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '400px', height: 'auto' }">

  <!-- HEADER CUSTOMIZADO COM WAVE (variante danger) -->
  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'produtos-edit.dialogs.remover_grupo_header' | translate }}</h2>
        <p>{{ 'produtos-edit.dialogs.remover_grupo_desc' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">
    <p>{{ mensagemRemoverGrupo }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="cancelarRemocaoGrupo()">
      {{ 'common.nao' | translate }} (Esc)
    </button>
    <button pButton severity="danger" icon="pi pi-trash" (click)="confirmarRemocaoGrupoFinal()">
      {{ 'common.sim' | translate }} (Enter)
    </button>
  </ng-template>
</p-dialog>
